import { CAST_AI } from '@cast/constants';

import { getDocsLink } from '@cast/utils';

import { ExternalLink, Typography } from '@cast/design-system';

export const NativeHpaMessage = () => {
  return (
    <Typography variant="P12R">
      To use {CAST_AI} horizontal rightsizing, please disable the native HPA
      first. Read more in the{' '}
      <ExternalLink link={getDocsLink('docs_woop_hpa')} noIcon>
        documentation
      </ExternalLink>
      .
    </Typography>
  );
};
